module.exports = __webpack_public_path__ + "static/media/qrcode.3b6c2ba9.png";